import { createRouter, createWebHistory } from 'vue-router'
import store from '../store';
import { trackFirebaseScreenView } from '../services/firebaseAnalytics';

const routes = [
  {
    path: '/',
    alias: ['/home', '/index'],
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Home')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login" */ '../views/Autenticacao/LoginView')
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: () => import(/* webpackChunkName: "SignUp" */ '../views/Autenticacao/SignUpView')
  },
  {
    path: '/dados/baixardados',
    name: 'BaixarDadosCe',
    component: () => import(/* webpackChunkName: "BaixarDadosCe" */ '../views/Dados/BaixarDadosCe'),
    meta: { requiresLogin: true }
  },
  {
    path: '/sobre',
    name: 'Sobre',
    component: () => import(/* webpackChunkName: "Sobre" */ '../views/Sobre'),
    meta: { requiresLogin: false }
  },
  {
    path: '/politica',
    name: 'Politica',
    beforeEnter: () => {
      window.location.replace('/politica.html')
      return false
    },
    component: { render: () => null },
    meta: { requiresLogin: false }
  },
  {
    path: '/saibamaissapi',
    name: 'SaibaMaisSAPI',
    component: () => import(/* webpackChunkName: "Sobre" */ '../views/SaibaMais'),
    meta: { requiresLogin: false }
  },
  {
    path: '/dados/paineladministrativo',
    name: 'PainelAdministrativo',
    component: () => import(/* webpackChunkName: "PainelAdministrativo" */ '../views/Dados/PainelAdministrativo'),
    meta: { requiresLogin: true }
  },
  {
    path: '/dados/regionais',
    name: 'GerenciarRegionais',
    component: () => import(/* webpackChunkName: "GerenciarRegionais" */ '../views/Dados/Regionais/GerenciarRegionais'),
    meta: { requiresLogin: true }
  },

  // Path que deve ser usado para Menu Regional - Recebendo o ID da Regional
  {
    path: '/dados/regionais/:idRegional',
    name: 'RegionalMenu',
    component: () => import(/* webpackChunkName: "GerenciarRegionais" */ '../views/Dados/Regionais/RegionalMenu'),
    meta: { requiresLogin: true }
  },
  {
    path: '/dados/regionais/:idRegional/municipios',
    name: 'GerenciarMunicipios',
    component: () => import(/* webpackChunkName: "GerenciarRegionais" */ '../views/Dados/Municipios/GerenciarMunicipios'),
    meta: { requiresLogin: true }
  },
  {
    path: '/dados/municipios/:idMunicipio',
    name: 'MunicipioMenu',
    component: () => import(/* webpackChunkName: "GerenciarRegionais" */ '../views/Dados/Municipios/MunicipioMenu'),
    meta: { requiresLogin: true }
  },
  {
    path: '/dados/gerenciar/cargos',
    name: 'ListarMembros',
    component: () => import(/* webpackChunkName: "ListarMembros" */ '../views/Dados/Lists/ListarMembros'),
    meta: { requiresLogin: true }
  },
  {
    path: '/dados/gerenciar/formularios',
    name: 'ListarFormularios',
    component: () => import(/* webpackChunkName: "ListarFormularios" */ '../views/Dados/Lists/ListarFormularios'),
    meta: { requiresLogin: true }
  },
  {
    path: '/dados/municipios/:idMunicipio/unidades',
    name: 'ListarUnidadesEducacionais',
    component: () => import(/* webpackChunkName: "ListarUnidadesEducacionais" */ '../views/Dados/Lists/ListarUnidadesEducacionais'),
    meta: { requiresLogin: true }
  },
  {
    path: '/dados/municipios/:idMunicipio/unidades/:idUnidade/turmas',
    name: 'ListarTurmas',
    component: () => import(/* webpackChunkName: "ListarTurmas" */ '../views/Dados/Lists/ListarTurmas'),
    meta: { requiresLogin: true }
  },
  {
    path: '/dados/regionais/:idRegional/:idMunicipio?/campos',
    name: 'ListarCampos',
    component: () => import(/* webpackChunkName: "ListarCampos" */ '../views/Dados/Lists/ListarCampos'),
    meta: { requiresLogin: true }
  },
  {
    path: '/dados/regionais/:idRegional/:idMunicipio?/camposRegional',
    name: 'ListarCamposRegional',
    component: () => import(/* webpackChunkName: "ListarCampos" */ '../views/Dados/Lists/ListarCamposRegional'),
    meta: { requiresLogin: true }
  },
  {
    path: '/dados/regionais/:idRegional/municipios/:idMunicipio/campos/:idCampo',
    name: 'CampoMenu',
    component: () => import(/* webpackChunkName: "CampoMenu" */ '../views/Dados/Campos/CampoMenu'),
    meta: { requiresLogin: true }
  },
  {
    path: '/dados/regionais/:idRegional/municipios/:idMunicipio/campos/:idCampo/membros',
    name: 'CampoListaMembros',
    component: () => import(/* webpackChunkName: "CampoListaMembros" */ '../views/Dados/Lists/CampoListaMembros'),
    meta: { requiresLogin: true }
  },
  {
    path: '/dados/regionais/:idRegional/municipios/:idMunicipio/campos/:idCampo/formularios',
    name: 'CampoListaFormularios',
    component: () => import(/* webpackChunkName: "CampoListaFormularios" */ '../views/Dados/Lists/CampoListaFormularios'),
    meta: { requiresLogin: true }
  },
  {
    path: '/dados/regionais/:idRegional/municipios/:idMunicipio/campos/:idCampo/unidades',
    name: 'CampoListaUnidadesEducacionais',
    component: () => import(/* webpackChunkName: "CampoListaUnidadesEducacionais" */ '../views/Dados/Lists/CampoListaUnidadesEducacionais'),
    meta: { requiresLogin: true }
  },
  {
    path: '/dados/regionais/:idRegional/municipios/:idMunicipio/campos/:idCampo/unidades/:idUnidade/turmas',
    name: 'CampoListaTurmas',
    component: () => import(/* webpackChunkName: "CampoListaTurmas" */ '../views/Dados/Lists/CampoListaTurmas'),
    meta: { requiresLogin: true }
  },
  {
    path: '/dados/regionais/:idRegional/municipios/:idMunicipio/campos/:idCampo/aplicacoes',
    name: 'AplicacoesListaCampos',
    component: () => import(/* webpackChunkName: "AplicacoesListaCampos" */ '../views/Dados/Lists/AplicacoesListaCampos'),
    meta: { requiresLogin: true }
  },
  {
    path: '/materiaisedocumentos/oquee',
    name: 'OQueE',
    component: () => import(/* webpackChunkName: "OQueE" */ '../views/MateriaiseDocumentos/OQueE')
  },
  {
    path: '/materiaisedocumentos/materiais',
    name: 'Materiais',
    component: () => import(/* webpackChunkName: "Materiais" */ '../views/MateriaiseDocumentos/Materiais')
  },
  {
    path: '/materiaisedocumentos/materiaisavaliacao',
    name: 'MateriaisAvaliacao',
    component: () => import(/* webpackChunkName: "MateriaisAvaliacao" */ '../views/MateriaiseDocumentos/MateriaisAvaliacao')
  },
  {
    path: '/materiaisedocumentos/videostutoriais',
    name: 'VideosTutoriais',
    component: () => import(/* webpackChunkName: "VideosTutoriais" */ '../views/MateriaiseDocumentos/VideosTutoriais')
  },
  {
    path: '/materiaisedocumentos/docoficiais',
    name: 'DocOficiais',
    component: () => import(/* webpackChunkName: "DocOficiais" */ '../views/MateriaiseDocumentos/DocOficiais')
  },
  {
    path: '/geradorformulario',
    name: 'GeradorFormulario',
    component: () => import(/* webpackChunkName: "GeradorFormulario" */ '../views/GeradorDeFormularios/GeradorFormularios'),
    meta: { requiresLogin: true }
  },
  {
    path: '/resetpassword',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: "RedefinirSenha" */ '../views/ResetPassword'),
    meta: { requiresLogin: false }
  },
  {
    path: '/registeraccount',
    name: 'ConfirmAccount',
    component: () => import(/* webpackChunkName: "AccountConfirmation" */ '../views/Autenticacao/UserConfirmation'),
    meta: { requiresLogin: false }
  },
  {
    path: '/panoramaSAPI/INAPI',
    name: 'INAPI',
    component: () => import(/* webpackChunkName: "ParanoramaSAPI" */ '../views/Panorama/PanoramaSAPI'),
    meta: { requiresLogin: true, dash: true }
  },
  {
    path: '/panoramaSAPI/INAPI/dimensao',
    name: 'Dimensao',
    component: () => import(/* webpackChunkName: "Dimensao" */ '../views/Panorama/Dimensao'),
    meta: { requiresLogin: true }
  },
  {
    path: '/panoramaSAPI/EAPI',
    name: 'EAPI',
    component: () => import(/* webpackChunkName: "Dimensao" */ '../views/Panorama/EAPI'),
    meta: { requiresLogin: true, dash: true }
  },

  //--------------------------------------------
  //ROTA 404 (DEVE SER SEMPRE A ULTIMA DA LISTA)
  {
    path: '/:catchAll(.*)',
    name: 'Error404',
    component: () => import(/* webpackChunkName: "Error404" */ '../views/Error404')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresLogin) && store.getters.getIsLogged == false) {
      store.commit("setDoNotHavePermissionLogin", true) // TODO! VERIFICAR O ESTADO PARA DAR UM ALERTA DE FALTA DE PERMISSAO
      next("/")
  } else {
      next()
  }
})

router.afterEach((to) => {
  trackFirebaseScreenView(to)
})

export default router
